import React from 'react';
import AuthenticatedNavbar from './headers/AuthenticatedNavbar';
import GroupsHubContent from './groups/Groups.js';

export default function GroupsHubPage({ user, onLogout }) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section>
        <GroupsHubContent user={user} />
      </section>
    </div>
  );
}
